import React from 'react';

import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';

import CrmIntegrations from './CrmIntegrations';
import DocumentEditingIntegrations from './DocumentEditing';
import EmailIntegrations from './EmailIntegrations';
import ESignatureIntegrations from './ESignatureIntegrations';
import StorageIntegrations from './StorageIntegrations';

export default function ThirdPartyIntegrations() {
  const multipleSFDCIntegrations = useFlag(
    FlagType.SupportMultipleSFDCOrganizations,
  );

  const documentEditingIntegrations = useFlag(FlagType.SharepointWizard);

  return (
    <FlexLayout flexDirection="column" space={10}>
      <ESignatureIntegrations />
      {multipleSFDCIntegrations || <CrmIntegrations />}
      {documentEditingIntegrations && <DocumentEditingIntegrations />}
      <EmailIntegrations />
      <StorageIntegrations />
    </FlexLayout>
  );
}
